<template>
  <section class="campaigns-testimonial">
    <div
      v-swiper:mySwiper="swiperOption"
      class="swiper-container"
    >
      <!-- Slides -->
      <div class="swiper-wrapper">
        <div
          v-for="(testimonial, index) in campaign.testimonials"
          :key="index"
          class="swiper-slide"
        >
          <figure
            v-if="testimonial.imageSrc !== undefined"
            class="campaigns-testimonial__image"
          >
            <picture>
              <source :data-srcset="getImageSrcset(testimonial)">

              <img
                class="lazyload"
                data-sizes="auto"
                :data-src="getImageSrc(testimonial)"
              >
            </picture>
          </figure>

          <div class="campaigns-testimonial__content">
            {{ testimonial.content }}
          </div>

          <div class="campaigns-testimonial__author">
            {{ testimonial.author }}
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="swiper-pagination swiper-pagination-bullets" />
    </div>

    <div class="campaigns-testimonial__action">
      <button-view
        variant="title"
        @click.native="scrollToForm()"
      >
        {{ campaign.button }}
      </button-view>
    </div>
  </section>
</template>

<script>
import campaigns from '@/mixins/campaigns';

export default {
  name: 'CampaignsTestimonial',

  components: {
    ButtonView: () => import('@/components/button/button-view')
  },

  mixins: [campaigns],

  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: 5000,
        initialSlide: 0,
        paginationElement: 'li',
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        paginationClickable: true
      }
    };
  },

  methods: {
    scrollToForm() {
      this.$scrollTo('#details');
    }
  }
};
</script>

<style
  lang="scss"
  src="@/assets/components/campaigns/campaigns-testimonial-view.scss"
></style>



// WEBPACK FOOTER //
// campaigns-testimonial-view.vue